import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import ResultChart from "components/common/ResultChart";
import { selectOptionList } from "../goal/Goal_6_Promotion";
import { useNavigate } from "react-router-dom";
import { BottomNextButton } from "../../../../components/common/BottomNextButton";
import { useOnboardingPromotionData } from "../../../../hooks/useOnboardingPromotionData";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Result_4_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  // const navigate = useUnifiedNavigate();
  const navigate = useNavigate();
  const handleNext = () => {
    if (version === "v4") {
      navigate(`/${versionToPathPrefix(version)}-login`, { replace: true });
    } else {
      navigate(`/${versionToPathPrefix(version)}-product`, { replace: true });
    }
  };

  const { singleSelectionId } = useOnboardingPromotionData("goal_6");
  const option = selectOptionList.find((e) => e.id === singleSelectionId);
  const labelPercentage = (option?.score || 24) + 16;

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Stack sx={{ paddingBottom: "150px" }}>
      <Stack
        spacing={2}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={700}
          sx={{
            color: theme.vars.palette.Content.Highlight,
          }}
        >
          {"최종 예측입니다."}
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {`8주 뒤 증상이 ${labelPercentage}% 호전될 것으로 예상됩니다.`}
        </CustomTypography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // 수평 가운데 정렬
          }}
        >
          <Box padding="40px 24px" maxWidth="380px" width="100%">
            <ResultChart labelValue={`${labelPercentage}%`} />
          </Box>
        </Box>
      </Stack>
      <Stack spacing={3}>
        <CustomTypography
          variant="Body"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Medium,
          }}
        >
          {`대단히 훌륭합니다. 나의 모든 답변을 종합해 분석한 결과, 기존 예상치보다 `}
          <Box
            component="span"
            sx={{
              color: theme.vars.palette.Content.Highlight,
              fontWeight: 700,
            }}
          >{`16%p 더 큰 폭`}</Box>
          {`의 증상 개선을 이룰 수 있을 것으로 예측됩니다.`}
        </CustomTypography>
        <CustomTypography
          variant="Body"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Medium,
          }}
        >
          {"이후 약 한 달 동안은 "}
          <Box
            component="span"
            sx={{
              color: theme.vars.palette.Content.Highlight,
              fontWeight: 700,
            }}
          >{`재발을 방지하고 치료 효과를 고착화`}</Box>
          {"하는 유지 치료에 집중할 것입니다."}
        </CustomTypography>
        <CustomTypography
          variant="Caption"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Medium,
          }}
        >
          {"* 위 예측치는 40만 개의 데이터 포인트로 분석한 결과임"}
        </CustomTypography>
      </Stack>
      <BottomNextButton
        disabled={false}
        onClick={handleNext}
        text={"맞춤 프로그램 결과 보기"}
      />
    </Stack>
  );
}
